export const authGroup = {
    ADMINISTRATORS: 'administrators',
    BROKERS: 'brokers',
    BUSINESS_DEPARTMENT: 'business_department',
    TECHNICAL: 'technical',
}

export const authGroupsList = [
    authGroup.ADMINISTRATORS,
    authGroup.BROKERS,
    authGroup.BUSINESS_DEPARTMENT,
    authGroup.TECHNICAL
]